import '../../../styles/admin/GameAdmin.css';
import GameTable from './GameTable.tsx';
import React from "react";
const GameAdmin = () => {

    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='container-game container-fluid'>
                    <div className='admin mt-2'>
                        <div className='container-adminGame'>
                            <select id='select-days' name='selectdays' className='select-game'>
                                <option value="manager">Today</option>
                                <option value="accounting">Yesterday</option>
                                <option value="detailed">Full Board</option>
                            </select>
                            <div>
                                <button className='button-game'>Games to Show</button>
                            </div>
                        </div>


                        <div className='container-adminGame'>
                            <select id='select-admin' name='selectadmin' className='select-game'>
                                <option value="manager">Master</option>
                                <option value="accounting">PPHINSIDER</option>
                            </select>
                            <select id='select-admin2' name='selectadmin2' className='select-game'>
                                <option value="manager">Admin</option>
                                <option value="accounting">Position</option>
                            </select>
                        </div>
                    </div>


                    <div className='admin-game  mt-1'>
                        <div>
                            <span>My Board</span>
                        </div>
                        <div>
                            <select id='select-game' name='selectgame' className=''>
                                <option value="manager">Game</option>
                            </select>

                            <select id='select-agent' name='selectagent' className=''>
                                <option value="manager">Contest</option>
                            </select>
                        </div>
                    </div>
                    <GameTable />
                </div>
            </div>
        </>
    )
}

export default GameAdmin;